import { Link } from "react-router-dom";
import { motion, Variants, Easing } from "framer-motion";
import GoogleReviewsBadge from "../GoogleReviewsBadge";
import Section from "../Common/Section";
import "./style.scss";

interface CustomerReviewsProps {
  order: "odd" | "even";
}

const itemVariants: Variants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: "easeOut" as Easing },
  },
};

const CustomerReviews: React.FC<CustomerReviewsProps> = ({ order }) => {
  return (
    <Section variant={order} className="customerReviews">
      <div className="sectionHeader">
        <h2 className="title">Highly Rated by Our Customers</h2>
        <div className="description">
          <p>
            We take pride in every window we clean, ensuring a spotless sparkle
            every time.
          </p>
          <Link to="/Reviews" className="reviewsLink">
            {" "}
            See what our customers say
          </Link>
        </div>
      </div>

      <motion.div className="reviewsContainer" variants={itemVariants}>
        <GoogleReviewsBadge />
      </motion.div>
    </Section>
  );
};

export default CustomerReviews;
